export default __webpack_public_path__ + "static/media/ttaConnectLogo.2a602965.svg";